// extracted by mini-css-extract-plugin
module.exports = {"phantomFull":"ArticlePreviewList-module--phantom-full--2-dyy","articleList":"ArticlePreviewList-module--articleList--1lBuO"};